import { render, staticRenderFns } from "./VoucherSegmentClientDetachedCreateModal.vue?vue&type=template&id=d8843ca8&scoped=true"
import script from "./VoucherSegmentClientDetachedCreateModal.vue?vue&type=script&lang=js"
export * from "./VoucherSegmentClientDetachedCreateModal.vue?vue&type=script&lang=js"
import style0 from "./VoucherSegmentClientDetachedCreateModal.vue?vue&type=style&index=0&id=d8843ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8843ca8",
  null
  
)

export default component.exports